import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import Navbar from '@/components/Home_Navbar/NavbarView.vue';
import proba from '@/assets/create_images/proba_logo.png';
import complyon from '@/assets/create_images/company.png';
import engagenet from '@/assets/create_images/community.png';
import orcaa from '@/assets/create_images/orcaa.png';
import workflow from '@/assets/create_images/project.png';
import xverdict from '@/assets/create_images/case.png';
import { csrf_headers, getCookie, get_token, get_user_id, is_demo_domain } from '@/router/index.js';
import { SYSTEM_MANAGEMENT_ENDPOINTS, build_system_management_url } from '@/constants/system_management_endpoints.js';
import { PLAYGROUND_PLATFORM_KEYS } from '@/utils/playground_platform_launch';

export default {
  name: 'HomeView',
  components: { Sidebar, Navbar },
  data: () => ({
    ai_open: false,
    is_collapsed: true,
    audits: [],
    csrfToken: '',
    project: 'AIC Campus – Default Workspace',
    user: {
      name: 'Loading...',
      tenant: 'AI Campus',
      roles: ['system_admin', 'org_admin', 'analyst'],
    },
    kpis: [
      { key: 'deploys', title: 'Active Deployments', value: 6, foot: '2 in last 7 days', icon: 'fa fa-rocket' },
      { key: 'ai_jobs', title: 'Running AI Jobs', value: 4, foot: 'Queued: 1', icon: 'fa-solid fa-robot' },
      { key: 'users', title: 'Users Online', value: 38, foot: '+6 vs yesterday', icon: 'fa-regular fa-user' },
      { key: 'cost', title: 'Cost (MoM)', value: 'R 12,430', foot: '-8% vs last month', icon: 'fa fa-chart-line' },
    ],
    app_catalog: [
      {
        key: 'proba',
        name: 'Proba Analytics',
        blurb: 'Dashboards, ESG and data pipelines.',
        icon: proba,
        roles: ['analyst', 'system_admin', 'org_admin'],
        kpis: { JOBS: 4, DATASETS: 12 },
        pill: 'Analytics',
      },
      {
        key: 'orcaa',
        name: 'Orcaa.ai',
        blurb: 'Assessments, learning paths and AI tutors.',
        icon: orcaa,
        roles: ['system_admin', 'org_admin', 'trainer', 'student'],
        kpis: { LEARNERS: 183, COURSES: 27 },
        pill: 'Learning',
      },
      {
        key: 'complyon',
        name: 'ComplyOn',
        blurb: 'Onboarding, KYC and compliance.',
        icon: complyon,
        roles: ['system_admin', 'org_admin', 'kyc_officer'],
        kpis: { COMPLIANCE: 9, PENDING: 3 },
        pill: 'Compliance',
      },
      {
        key: 'engagenet',
        name: 'EngageNet',
        blurb: 'Community, knowledge hub and collaboration.',
        icon: engagenet,
        roles: ['system_admin', 'org_admin', 'analyst', 'trainer', 'student'],
        kpis: { TOPICS: 42, REPLIES: 126 },
        pill: 'Community',
      },
      {
        key: 'proba workflows',
        name: 'Proba Workflows',
        blurb: 'Onboarding, workflow builder & verification.',
        icon: workflow,
        roles: ['system_admin', 'org_admin', 'analyst'],
        kpis: { WORKFLOWS: 78, VERIFICATION: 2 },
        pill: 'Verification',
      },
      {
        key: 'X-Verdict',
        name: 'X-Verdict',
        blurb: 'Case Management & Legal AI tools.',
        icon: xverdict,
        roles: ['system_admin', 'org_admin', 'analyst', 'project_manager'],
        kpis: { CASES: 6, TASKS: 124 },
        pill: 'Delivery',
      },
    ],
    recent_activity: [
      { t: 'Proba job completed', d: 'ESG-ETL pipeline finished in 6m 21s' },
      { t: 'ComplyOn workflow submitted', d: 'Tenant KYC – 3 pending approvals' },
      { t: 'EngageNet post', d: '‘Data governance quick tips’ – 12 replies' },
      { t: 'AIC Trail', d: '432 audit events in last 24h' },
    ],
  }),
  computed: {
    visible_apps() {
      const set = new Set(this.user.roles);
      const apps = this.app_catalog.filter(a => a.roles.some(r => set.has(r)));

      if (is_demo_domain() || localStorage.getItem('is_playground_user') === '1') {
        return apps.filter((app) => PLAYGROUND_PLATFORM_KEYS.includes(this.normalize_platform_key(app.key)));
      }

      return apps;
    },

    recent_from_audits() {
      if (Array.isArray(this.audits) && this.audits.length) {
        return this.audits
          .slice(0, 4)
          .map(this.map_audit_to_row)
          .filter(Boolean);
      }
      return this.recent_activity;
    },
  },
  mounted() {
    this.csrfToken = getCookie("csrftoken");
    const saved = localStorage.getItem('aic_one_my_apps_collapsed');
  if (saved === null) {
    this.is_collapsed = true;
    localStorage.setItem('aic_one_my_apps_collapsed', '1');
  } else {
    this.is_collapsed = (saved === '1');
  }
    this.load_user_details();
    this.fetchAudits();
  },

  methods: {
    toggle_collapse() {
      this.is_collapsed = !this.is_collapsed;
      localStorage.setItem('aic_one_my_apps_collapsed', this.is_collapsed ? '1' : '0');
    },

    _safe_lookup(obj, key) {
      const desc = Object.getOwnPropertyDescriptor(obj, key);
      return (desc && desc.enumerable) ? desc.value : undefined;
    },

    on_open_click(app) {
      const key = this.normalize_platform_key(app?.key);
      this.launch_platform(key);
    },

    normalize_platform_key(raw) {
      const k = String(raw || '').trim().toLowerCase();

      const alias_map = Object.freeze({
        __proto__: null,
        'x-verdict': 'x-verdict',
        'xverdict': 'x-verdict',
        'proba workflows': 'workflow',
        'proba-workflows': 'workflow',
        'workflows': 'workflow',
        'workflow': 'workflow',
        'proba': 'proba',
        'orcaa': 'orcaa',
        'engagenet': 'engagenet',
        'icworkbook': 'engagenet',
        'ic workbook': 'engagenet',
        'complyon': 'complyon',
      });

      return this._safe_lookup(alias_map, k) || k;
    },

    playground_platform_id(key) {
      const alias_map = Object.freeze({
        __proto__: null,
        'x-verdict': ['x-verdict', 'x verdict', 'xverdict'],
        'orcaa': ['orcaa', 'orcaa.ai'],
        'proba': ['proba', 'proba analytics'],
        'engagenet': ['engagenet', 'engage net', 'ic workbook'],
        'workflow': ['workflow', 'workflows', 'proba workflows', 'proba-workflows'],
        'complyon': ['complyon', 'comply on'],
      });
      const names = this._safe_lookup(alias_map, key) || [key];

      try {
        const platforms = JSON.parse(localStorage.getItem('playground_platforms') || '[]');
        const platform = Array.isArray(platforms)
          ? platforms.find((item) => names.includes(String(item?.name || '').trim().toLowerCase()))
          : null;
        return platform?.id || null;
      } catch {
        return null;
      }
    },

    async prepare_playground_platform_session(key) {
      if (localStorage.getItem('is_playground_user') !== '1') {
        return true;
      }

      const context_id = localStorage.getItem('playground_context_id');
      const platform_id = this.playground_platform_id(key);

      if (!context_id || !platform_id) {
        this.$notyf.error('Playground context is not ready yet');
        return false;
      }

      try {
        const token = get_token();
        const response = await fetch(
          build_system_management_url(SYSTEM_MANAGEMENT_ENDPOINTS.prepare_playground_platform_session),
          {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              ...(token ? { 'Authorization': `Token ${token}` } : {}),
              ...csrf_headers(this.csrfToken),
            },
            body: JSON.stringify({ context_id, platform_id }),
          },
        );
        const body = await response.json();

        if (response.status === 409 || body.status === 'expired') {
          this.$notyf.error(body.message || 'Your Playground session has expired');
          this.$router.push({ name: 'Login' });
          return false;
        }

        if (!response.ok || body.status !== 'success') {
          this.$notyf.error(body.message || 'Unable to prepare this platform');
          return false;
        }

        const redirect_url = body.data?.redirect_url;
        if (redirect_url) {
          window.location = redirect_url;
          return false;
        }

        return true;
      } catch {
        this.$notyf.error('Unable to prepare this platform');
        return false;
      }
    },

    async load_user_details() {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_current_user/`;
      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          const user_data = response_data.data;

          this.user.first_name = user_data.first_name || '';
          this.user.last_name = user_data.last_name || '';
          this.user.name = `${user_data.first_name} ${user_data.last_name}`;
          this.user.tenant = user_data.tenant || 'AI Campus';
          this.user.roles = user_data.roles || ['system_admin', 'org_admin', 'analyst'];

          if (user_data.first_name && user_data.last_name) {
            this.user_initials = user_data.first_name[0].toUpperCase() + user_data.last_name[0].toUpperCase();
          }
        }
      } catch (error) {
        this.$notyf.info('Error fetching user details');
      }
    },

    async launch_platform(plaform) {
      const token = get_token();

        if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }
      const user_id = get_user_id();
      const key = String(plaform || '').toLowerCase();

      if (!/^[a-z0-9_-]+$/i.test(key)) {
        this.$notyf.error('Unknown platform: invalid key');
        return;
      }

      const platform_session_ready = await this.prepare_playground_platform_session(key);
      if (!platform_session_ready) {
        return;
      }

      const endpoint_map = Object.freeze({
        __proto__: null,
      'x-verdict': '/aic_one_api/system_management/launch_xverdict/',
      'orcaa': '/aic_one_api/system_management/launch_orcaa/',
      'proba': '/aic_one_api/system_management/launch_proba/',
      'engagenet': '/aic_one_api/system_management/launch_engagenet/',
      'workflow': '/aic_one_api/system_management/launch_proba_workflow/',
      'complyon': '/aic_one_api/system_management/launch_complyon/',
      });

      const desc = Object.getOwnPropertyDescriptor(endpoint_map, key);
      const path = (desc && desc.enumerable && typeof desc.value === 'string') ? desc.value : null;

      if (!path) {
        this.$notyf.error(`Unknown platform: ${key}`);
        return;
      }

      const api_url = `${process.env.VUE_APP_API_BASE_URL}${path}`;

      try {
        const res = await fetch(api_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-Page-URL': window.location.href,
            ...csrf_headers(this.csrfToken),
          },
          body: JSON.stringify({ user_id })
        });

        if (!res.ok) {
          const data = await res.json();
          this.$notyf.error(data.message || data.detail || `HTTP error! status: ${res.status}`);
          return;
        }
        const data = await res.json();
        const redirect_url = data.redirect_url || data.data?.redirect_url;
        if (data.status === 'success' && redirect_url) {
          const safe_url = redirect_url;
          window.location = safe_url;

        } else {
          this.$notyf.error('Failed to launch platform');
        }
      } catch (error) {
        this.$notyf.error('Failed to launch ');
      }
    },

    async fetchAudits() {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_all_audits/`;
      const token = get_token();

      try {
        const res = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${token}`,
            "X-CSRFToken": this.csrf_token
          },
        });

        if (!res.ok) {
          const data = await res.json();
          this.$notyf.error(data.message || `Failed to fetch audits: HTTP ${res.status}`);
          return;
        }

        const data = await res.json();
        if (res.ok && data.status === "success") {
          // keep order assuming backend already returns newest first; adjust if needed
          this.audits = Array.isArray(data.data) ? data.data : [];
        } else {
          console.error("Error fetching audits:", data.message || "Unknown error");
        }
      } catch (err) {
        console.error("Network error:", err);
      }
    },

    map_audit_to_row(a) {
      return (a && typeof a === 'object')
        ? { t: String(this.extract_title(a)), d: this.build_description(a) || '—' }
        : null;
    },

    extract_title(audit) {
      return audit.title ||
             audit.action ||
             audit.event ||
             audit.type ||
             audit.category ||
             `${audit.app || audit.source || 'System'} event`;
    },

    build_description(audit) {
      const bits = [
        audit.description || audit.message || audit.summary,
        audit.entity || audit.object || audit.target,
        audit.status,
        audit.duration ? String(audit.duration) : null,
        this.formatDate(audit.created_at || audit.timestamp || audit.time),
      ].filter(Boolean);
      return bits.join(' · ');
    },

    formatDate(d) {
      if (!d) return null;
      try {
        const dt = new Date(d);
        if (isNaN(dt.getTime())) return null;
        return dt.toLocaleString();
      } catch {
        return null;
      }
    },

    go_to_page(url) {
      if (url) {
        window.location = url;
      } else {
        this.$notyf.info("No page URL available");
      }
    },
  },
};
